.markdown {
  a {
    &:hover {
      text-decoration: underline;
    }
  }

  img {
    max-width: 100%;
  }

  /* restore list style stripped by global reset */
  ul {
    list-style: disc;
    padding-left: 24px;
    white-space: normal;
  }

  ol {
    list-style: decimal;
    padding-left: 24px;
    white-space: normal;
  }

  /* keep line breaks inside an item */
  li {
    white-space: pre-line;
    & + li {
      margin-top: 8px;
    }
  }

  p {
    white-space: pre-line;
    & + p {
      margin-top: 8px;
    }
  }
}
